<template>
  <div
    v-if="isLoading"
    class="loading-overlay"
  >
    <div class="loading-content">
      <b-loading
        :is-full-page="false"
        :active="isLoading"
        :can-cancel="false"
      />
      <p class="mt-4">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: 'Bitte warten...',
  },
});
</script>
